module.exports = __webpack_public_path__ + "static/media/financim.07d7be34.jpg";